import wrapperFactory from "../util/wrapper-factory.js";

export default async function signupForm() {
  const exported = await wrapperFactory({ name: "signup-form-v1" });
  return exported.default;
}
